import {ref, Ref} from "vue";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import Translator from "@/utils/common/Translator.ts";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import DTOGeneralAnnouncementInfo = namaTypes.DTOGeneralAnnouncementInfo;

const ROTATION_INTERVAL_MS = 5000;

export interface GeneralAnnouncement {
  key: string;
  text: string;
}

export default class GeneralAnnouncementsUtil {
  static announcements: Ref<GeneralAnnouncement[]> = ref([]);
  static index: Ref<number> = ref(0);
  private static rotationTimer: number | undefined = undefined;

  static async load() {
    if (!LoginUtils.currentUserInfo()?.id)
      return;
    let result = await NamaCommon.namaFetch(NamaURLS.FETCH_GENERAL_ANNOUNCEMENTS, {method: 'get', noLoadingIndicator: true});
    this.announcements.value = this.toAnnouncements(result?.list ?? []);
    this.index.value = 0;
  }

  static current(): GeneralAnnouncement | undefined {
    return this.announcements.value[this.index.value];
  }

  static goTo(target: number) {
    this.stopRotation();
    let count = this.announcements.value.length;
    if (count === 0)
      return;
    this.index.value = ((target % count) + count) % count;
  }

  static next() {
    this.goTo(this.index.value + 1);
  }

  static previous() {
    this.goTo(this.index.value - 1);
  }

  static stopRotation() {
    if (this.rotationTimer === undefined)
      return;
    clearInterval(this.rotationTimer);
    this.rotationTimer = undefined;
  }

  private static toAnnouncements(list: DTOGeneralAnnouncementInfo[]): GeneralAnnouncement[] {
    return list.filter(dto => !!dto.id).flatMap(dto => (dto.texts ?? []).map((line, order) => ({
      key: dto.id + "#" + order,
      text: Translator.getName(line.arabicText, line.englishText)
    }))).filter(announcement => !!announcement.text);
  }

  static startRotation() {
    this.stopRotation();
    if (this.announcements.value.length <= 1)
      return;
    this.rotationTimer = window.setInterval(() => {
      this.index.value = (this.index.value + 1) % this.announcements.value.length;
    }, ROTATION_INTERVAL_MS);
  }
}
